import type { TmWrappers } from '@/wrappers'

export const addNewPinnedItemModalId = 'addNewPinnedContactsModal' satisfies TmWrappers

export const PINNED_CONTACTS_ITEMS_PER_PAGE = 25
